import * as React from "react";
import * as palette from "../palette";

interface IRemessaOnlineDiscountAdvertisementProps {
  onClose: () => void;
}

export default function RemessaOnlineDiscountAdvertisement({ onClose }: IRemessaOnlineDiscountAdvertisementProps) {
  return (
    <div
      css={{
        position: "relative",
        display: "grid",
        gridColumnGap: 30,
        gridTemplateColumns: "repeat(12, 1fr)",
        boxSizing: "border-box",
        width: "100%",
        padding: 24,
        backgroundColor: "#4499F8",
        borderRadius: 6,
        borderTopRightRadius: 0,
        boxShadow: "0 1px 3px 0 #33333333",
      }}
    >
      <div
        css={{
          gridColumn: "span 12",
        }}
      >
        <RemessaOnline width={170} height={22} />

        <p
          css={{
            margin: 0,
            marginTop: 16,
            color: palette.white,
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 1.33,
            letterSpacing: 1,
          }}
        >
          Aproveite a parceria que fizemos com a Remessa Online e utilize o cupom <CouponCode>FUNDAMENTEI</CouponCode>{" "}
          para ganhar 15% de desconto na sua remessa para o exterior!
        </p>
      </div>

      <div
        css={{
          position: "absolute",
          top: 0,
          right: 0,
          marginTop: -12,
          marginRight: -12,
        }}
      >
        <button
          type="button"
          aria-label="Fechar"
          onClick={() => onClose()}
          css={{
            display: "flex",
            boxSizing: "border-box",
            margin: 0,
            padding: 0,
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <TimesIcon width={24} height={24} />
        </button>
      </div>
    </div>
  );
}

function CouponCode({ children }: React.HTMLProps<HTMLElement>) {
  return (
    <strong
      css={{
        padding: "2px 6px",
        fontSize: 13,
        lineHeight: 1.33,
        backgroundColor: palette.mariner,
        borderRadius: 4,
      }}
    >
      {children}
    </strong>
  );
}

function RemessaOnline(props: React.SVGProps<any>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 170 22" {...props}>
      <path
        d="M10.3 6.8l8.4 4.9v3.7l-8.4-4.9c-.6-.3-1.3-.3-1.9 0L0 15.4v-3.7l8.4-4.9c.6-.3 1.3-.3 1.9 0zM1.4 17.4l7-4.1c.6-.4 1.4-.4 2 0l7 4.1-7 4.1c-.6.4-1.4.4-2 0l-7-4.1zM10.3.3l8.4 4.9v3.7L10.3 4c-.6-.4-1.3-.4-1.9-.1L0 8.8V5.2L8.4.3c.6-.4 1.3-.4 1.9 0zM25.5 4c0-.2.2-.4.4-.4h4.6c.7 0 1.3.1 2 .2.6.1 1.2.4 1.7.7.5.3.9.8 1.2 1.3.3.5.4 1.2.4 1.9 0 1-.3 1.9-.9 2.6-.5.5-1.1.9-1.9 1.2-.3.1-.4.4-.3.6l3.2 5.3c.2.3 0 .6-.4.6h-2.1c-.2 0-.3-.1-.4-.2l-3-5.7c-.1-.1-.2-.2-.4-.2h-1.2c-.2 0-.4.2-.4.4v5.3c0 .2-.2.4-.4.4h-1.7c-.2 0-.4-.2-.4-.4V4zm4.6 5.8c.4 0 .7 0 1.1-.1.4-.1.7-.2 1-.3.3-.2.6-.4.8-.7.2-.3.3-.6.3-1.1 0-.4-.1-.7-.3-1-.2-.3-.4-.5-.7-.6-.3-.1-.6-.3-.9-.3-.3-.1-.7-.1-1-.1H28v4.1h2.1v.1zm16.8 3.4c0 .1 0 .4-.2.5-.1.1-.5.1-.5.1h-6.8c0 .4.1.7.3 1 .2.3.4.5.6.8.3.2.6.4.9.5.3.1.7.2 1 .2.6 0 1.1-.1 1.6-.3.3-.2.6-.4.8-.6.2-.2.4-.2.6-.1l1 .8c.2.1.2.4.1.6-1 1.1-2.3 1.6-3.9 1.6-.8 0-1.5-.1-2.1-.4-.6-.3-1.2-.6-1.7-1s-.8-1-1.1-1.6c-.3-.6-.5-1.3-.5-2.1s.1-1.5.4-2.2c.3-.6.6-1.2 1.1-1.7.5-.5 1-.8 1.6-1.1.6-.3 1.3-.4 2.1-.4.7 0 1.3.1 1.9.3.6.2 1.1.6 1.5 1 .4.4.8 1 1 1.7.2.8.3 1.5.3 2.4zm-2.5-1.1c0-.3 0-.6-.1-.9-.1-.3-.2-.5-.4-.8-.2-.2-.4-.4-.7-.5-.3-.1-.6-.2-1-.2-.7 0-1.4.2-1.9.7-.5.4-.8 1-.8 1.7h4.9zm16.2-4.2c.6 0 1.2.1 1.6.3.5.2.8.5 1.1.9.3.4.5.8.6 1.3.1.5.2 1 .2 1.5v5.7c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4v-5c0-.3 0-.6-.1-.9-.1-.3-.1-.6-.3-.8-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1-.2s-.7.1-1 .2c-.3.2-.5.4-.7.6-.2.2-.3.5-.4.9-.1.3-.1.6-.1 1v4.9c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4v-5.5c0-.6-.1-1.1-.4-1.5-.3-.4-.8-.6-1.4-.6-.4 0-.7.1-1 .2-.3.2-.5.4-.7.6-.2.2-.3.5-.4.8-.1.3-.1.6-.1 1v5c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4v-9c0-.2.2-.4.4-.4h1.5c.2 0 .4.2.4.4v1.1c.1-.2.3-.5.4-.7.1-.2.4-.4.7-.6.3-.2.5-.3.9-.4.3-.1.7-.2 1.1-.2.8 0 1.4.2 1.9.5s.9.8 1.2 1.3c.3-.6.8-1.1 1.3-1.4.7-.2 1.3-.4 2.1-.4zM76 13.2c0 .1 0 .3-.2.5s-.4.2-.4.2h-6.9c0 .4.1.7.3 1 .2.3.4.5.6.8.3.2.6.4.9.5.3.1.7.2 1 .2.6 0 1.1-.1 1.6-.3.3-.2.6-.4.8-.6.2-.2.4-.2.6-.1l1 .8c.2.1.2.4.1.6-1 1.1-2.3 1.6-3.9 1.6-.8 0-1.5-.1-2.1-.4-.6-.3-1.2-.6-1.7-1s-.8-1-1.1-1.6c-.3-.6-.4-1.4-.4-2.2 0-.8.1-1.5.4-2.2.3-.6.6-1.2 1.1-1.7.5-.5 1-.8 1.6-1.1.6-.3 1.3-.4 2.1-.4.7 0 1.3.1 1.9.3.6.2 1.1.6 1.5 1 .4.4.8 1 1 1.7.1.8.2 1.5.2 2.4zm-2.5-1.1c0-.3 0-.6-.1-.9-.1-.3-.2-.5-.4-.8-.2-.2-.4-.4-.7-.5-.3-.1-.6-.2-1-.2-.7 0-1.4.2-1.9.7-.5.4-.8 1-.8 1.7h4.9zm9.9-1.4c-.1 0-.3-.1-.4-.2-.2-.1-.3-.3-.5-.4-.4-.2-.8-.3-1.2-.3-.4 0-.8.1-1.1.2-.3.2-.5.4-.5.8s.2.7.5.8c.4.2.9.3 1.6.5.4.1.7.2 1.1.3.4.1.7.3 1 .5.3.2.6.5.7.8.2.3.3.7.3 1.2 0 .6-.1 1.1-.3 1.5-.2.4-.5.8-.9 1-.4.3-.8.4-1.3.6-.5.2-1 .2-1.5.2-.8 0-1.5-.1-2.2-.4-.6-.2-1.1-.5-1.5-.9-.2-.2-.2-.5 0-.6l1-.9c.2-.2.4-.1.6 0 .2.2.5.4.8.6.4.2.9.3 1.5.3.2 0 .4 0 .5-.1.2 0 .4-.1.5-.2.2-.1.3-.2.4-.4.1-.1.1-.3.1-.6 0-.4-.2-.7-.6-.9-.4-.2-.9-.4-1.7-.5-.4-.1-.7-.2-1.1-.3-.3-.1-.7-.3-.9-.5-.3-.2-.5-.5-.7-.8-.2-.3-.2-.7-.2-1.2s.1-1 .3-1.4c.2-.4.5-.7.9-1 .4-.3.8-.4 1.2-.6.5-.1.9-.2 1.4-.2.7 0 1.4.1 2.1.4.5.2 1 .5 1.3.8.2.2.1.4 0 .6l-.9.8c0 .3-.2.5-.3.5zm8.6 0c-.2 0-.2-.1-.3-.2-.2-.2-.4-.3-.6-.4-.4-.2-.8-.3-1.2-.3-.4 0-.8.1-1.1.2-.3.2-.5.4-.5.8s.2.7.5.8c.4.2.9.3 1.6.5.4.1.7.2 1.1.3.4.1.7.3 1 .5.3.2.6.5.7.8.2.3.3.7.3 1.2 0 .6-.1 1.1-.3 1.5-.2.4-.5.8-.9 1-.3.4-.8.6-1.3.7-.5.1-1 .2-1.5.2-.8 0-1.5-.1-2.2-.4-.6-.2-1.1-.5-1.5-.9-.2-.2-.2-.5 0-.6l1-.9c.2-.2.4-.1.6 0 .2.2.5.4.8.6.4.2.9.3 1.5.3.2 0 .4 0 .5-.1.2 0 .4-.1.5-.2.2-.1.3-.2.4-.4.1-.1.1-.3.1-.6 0-.4-.2-.7-.6-.9-.4-.2-.9-.4-1.7-.5-.4-.1-.7-.2-1.1-.3-.3-.1-.7-.3-.9-.5-.3-.2-.5-.5-.7-.8-.2-.3-.2-.6-.2-1.1 0-.5.1-1 .3-1.4.2-.4.5-.7.9-1 .4-.3.8-.4 1.2-.6.5-.1.9-.2 1.4-.2.7 0 1.4.1 2.1.4.5.2 1 .5 1.3.8.2.2.1.4 0 .6l-1 .8c.1.1 0 .3-.2.3zm9.4 6.1c-.3.4-.7.8-1.2 1.1-.5.3-1.2.4-1.9.4-.4 0-.8-.1-1.2-.2-.4-.1-.8-.3-1.2-.5-.4-.2-.7-.6-.9-.9-.2-.4-.4-.9-.4-1.4 0-.7.2-1.3.6-1.8.4-.4 1-.8 1.6-1 .7-.2 1.4-.4 2.2-.5.8-.1 1.6-.1 2.3-.1v-.2c0-.6-.2-1.1-.7-1.4-.4-.3-1-.4-1.6-.4-.5 0-1 .1-1.5.3-.3.1-.6.3-.9.5-.2.1-.4.1-.6 0l-.7-.8c-.2-.2-.1-.5 0-.6.5-.4 1-.7 1.6-.9.7-.3 1.5-.4 2.2-.4.9 0 1.6.1 2.2.4.6.3 1 .6 1.3 1 .3.4.6.8.7 1.3.1.5.2 1 .2 1.5v5.5c0 .2-.2.4-.4.4h-1.9v-1.3h.2zm-.1-3.3h-.6c-.4 0-.8 0-1.2.1-.4 0-.8.1-1.2.2-.4.1-.7.3-.9.5-.2.2-.4.5-.4.9 0 .2.1.4.2.6.1.2.2.3.4.4.2.1.3.2.6.2.2 0 .4.1.6.1.8 0 1.5-.2 1.9-.7.4-.4.7-1.1.7-1.8v-.5h-.1zm7.9-2.8c0-1.2.2-2.2.6-3.1.4-.9.9-1.7 1.6-2.4.7-.7 1.5-1.2 2.5-1.5.9-.4 2-.5 3.1-.5s2.2.2 3.1.5c1 .4 1.8.9 2.5 1.5.7.7 1.2 1.4 1.6 2.4.4.9.6 2 .6 3.1s-.2 2.2-.6 3.1c-.4.9-.9 1.7-1.6 2.4-.7.7-1.5 1.2-2.5 1.6-1 .4-2 .6-3.1.6s-2.1-.2-3.1-.6c-.9-.4-1.8-.9-2.5-1.6-.7-.7-1.2-1.5-1.6-2.4-.4-.9-.6-1.9-.6-3.1zm2.8 0c0 .8.1 1.5.4 2.1.2.6.6 1.2 1 1.7s1 .8 1.6 1.1c.6.3 1.3.4 2 .4s1.4-.1 2-.4c.6-.3 1.1-.6 1.6-1.1.4-.5.8-1 1-1.7.2-.6.4-1.4.4-2.1 0-.7-.1-1.4-.4-2.1-.2-.6-.6-1.2-1-1.7s-1-.9-1.6-1.1c-.6-.3-1.3-.4-2-.4-.8 0-1.4.1-2 .4-.6.3-1.1.6-1.6 1.1-.4.5-.8 1-1 1.7-.2.7-.4 1.4-.4 2.1zm15.2-2.5h1.5c.2 0 .4.2.4.4v1.1c.2-.5.6-.9 1.1-1.3.5-.4 1.2-.6 1.9-.6.6 0 1.2.1 1.6.3.5.2.8.5 1.1.9.3.4.5.8.6 1.3.1.5.2 1 .2 1.5v5.7c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4v-5c0-.3 0-.6-.1-.9-.1-.3-.1-.6-.3-.8-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1-.2s-.7.1-1 .2c-.3.2-.5.4-.7.6-.2.2-.3.5-.4.8-.1.3-.1.6-.1 1v5c0 .2-.2.4-.4.4H127c-.2 0-.4-.2-.4-.4v-9c.2-.2.3-.4.6-.4zm11.5-5.6h1.6c.2 0 .4.2.4.4v14.6c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4V3c0-.3.2-.4.4-.4zm4.3 2.3c0-.4.1-.7.4-1 .3-.3.7-.4 1.1-.4.5 0 .8.1 1.1.4.3.3.5.6.5 1.1 0 .4-.2.8-.5 1.1-.3.3-.7.4-1.1.4-.4 0-.8-.1-1.1-.4-.3-.3-.4-.8-.4-1.2zm.8 3.3h1.6c.2 0 .4.2.4.4v9c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4v-9c0-.2.1-.4.4-.4zm5 0h1.5c.2 0 .4.2.4.4v1.1c.2-.5.6-.9 1.1-1.3.5-.4 1.2-.6 1.9-.6.6 0 1.2.1 1.6.3.5.2.8.5 1.1.9.3.4.5.8.6 1.3.1.5.2 1 .2 1.5v5.7c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4v-5c0-.3 0-.6-.1-.9-.1-.3-.1-.6-.3-.8-.1-.3-.3-.5-.6-.6-.3-.1-.6-.2-1-.2s-.7.1-1 .2c-.3.2-.5.4-.7.6-.2.2-.3.5-.4.8-.1.3-.1.6-.1 1v5c0 .2-.2.4-.4.4h-1.6c-.2 0-.4-.2-.4-.4v-9c.2-.2.4-.4.6-.4zm20.4 5c0 .1 0 .3-.2.5-.1.1-.5.2-.5.2h-6.9c0 .4.1.7.3 1 .2.3.4.5.6.8.3.2.6.4.9.5.3.1.7.2 1 .2.6 0 1.1-.1 1.6-.3.3-.2.6-.4.8-.6.2-.2.4-.2.6-.1l1 .8c.2.1.2.4.1.6-1 1.1-2.3 1.6-3.9 1.6-.8 0-1.5-.1-2.1-.4-.6-.3-1.2-.6-1.7-1s-.8-1-1.1-1.6c-.3-.6-.4-1.4-.4-2.2 0-.8.1-1.5.4-2.2.3-.6.6-1.2 1.1-1.7.5-.5 1-.8 1.6-1.1.6-.3 1.3-.4 2.1-.4.7 0 1.3.1 1.9.3.6.2 1.1.6 1.5 1 .4.4.8 1 1 1.7.2.8.3 1.5.3 2.4zm-2.4-1.1c0-.3 0-.6-.1-.9-.1-.3-.2-.5-.4-.8-.2-.2-.4-.4-.7-.5-.3-.1-.6-.2-1-.2-.7 0-1.4.2-1.9.7-.5.4-.8 1-.8 1.7h4.9z"
        fill="#FFF"
      />
    </svg>
  );
}

function TimesIcon(props: React.SVGProps<any>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 28" {...props}>
      <g fill="none">
        <path
          fill="#A53131"
          d="M14 0C6.266 0 0 6.266 0 14s6.266 14 14 14 14-6.266 14-14S21.734 0 14 0zm6.865 17.675a.677.677 0 010 .96l-2.236 2.23a.677.677 0 01-.96 0L14 17.16l-3.675 3.704a.677.677 0 01-.96 0l-2.23-2.236a.677.677 0 010-.96L10.84 14l-3.704-3.675a.677.677 0 010-.96L9.371 7.13a.677.677 0 01.96 0L14 10.839l3.675-3.704a.677.677 0 01.96 0l2.235 2.236a.677.677 0 010 .96L17.161 14l3.704 3.675z"
        />
        <path
          fill="#FFF"
          d="M20.865 17.675a.677.677 0 010 .96l-2.236 2.23a.677.677 0 01-.96 0L14 17.16l-3.675 3.704a.677.677 0 01-.96 0l-2.23-2.236a.677.677 0 010-.96L10.84 14l-3.704-3.675a.677.677 0 010-.96L9.371 7.13a.677.677 0 01.96 0L14 10.839l3.675-3.704a.677.677 0 01.96 0l2.235 2.236a.677.677 0 010 .96L17.161 14l3.704 3.675z"
        />
      </g>
    </svg>
  );
}
